/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringnumberofevents3Inputs */

const en_recurringnumberofevents3 = /** @type {(inputs: Recurringnumberofevents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of events`)
};

const de_recurringnumberofevents3 = /** @type {(inputs: Recurringnumberofevents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Ereignisse`)
};

/**
* | output |
* | --- |
* | "Number of events" |
*
* @param {Recurringnumberofevents3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringnumberofevents3 = /** @type {((inputs?: Recurringnumberofevents3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringnumberofevents3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringnumberofevents3(inputs)
	return de_recurringnumberofevents3(inputs)
});
export { recurringnumberofevents3 as "recurringNumberOfEvents" }